module.exports = "input.ng-invalid.ng-touched {\r\n\tborder: 1px solid red;\r\n}\r\n\r\n.btn[disabled] {\r\n\tcursor: not-allowed;\r\n}\r\n\r\nh5 {\r\n\ttext-align: center;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/changepass-modal/changepass-modal.component.css
// module id = ./src/app/changepass-modal/changepass-modal.component.css
// module chunks = main